import gql from "graphql-tag";

export default gql`
  query help($siteId: [QueryArgument]) {
    page: entry(section: "help", siteId: $siteId) {
      title
      ... on help_help_Entry {
        icon {
          url
        }
        byPhoneTitle
        byPhoneDescription
        questionnaireLinks {
          ... on questionnaireLinks_questionnairelink_BlockType {
            id
            questionnaireTitle
            questionnaireNote
            entryLink
          }
        }
        formHeaders {
          ... on formHeaders_headerForm_BlockType {
            id
            headerTitle
            headerDescription
          }
        }
        inPersonTitle
        inPersonDescription
        helpCenter {
          ... on helpCenter_regionGroup_BlockType {
            id
            text: regionGroupTitle
          }
          ... on helpCenter_helpCenter_BlockType {
            id
            text: region
            adresse
          }
        }
        bySmsTitle
        bySmsDescription
        linkGroup {
          ... on linkGroup_externalLink_BlockType {
            linkTitle
            linkUrl
          }
        }
      }
    }
    decidedBlock: globalSet(handle: "qst", siteId: $siteId) {
      ... on qst_GlobalSet {
        decidedBlock {
          ... on decidedBlock_decidedBlock_BlockType {
            blockTitle
            image {
              url
            }
            description
            buttonTitle
            buttonTitle
          }
        }
      }
    }
  }
`;
